import { render } from "./TheRouting.vue?vue&type=template&id=6a616570"
import script from "./TheRouting.vue?vue&type=script&lang=js"
export * from "./TheRouting.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\hagino\\work\\src\\plus-manabi\\mplus-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__